import Common from '../common/Common';
import gsap from "gsap";

class PlatformDownload {
    constructor({ data, l10nData }) {
        if(!data || !l10nData) {
            return;
        }

        const com = Common.instance;

        this.data = data;
        this.l10nData = l10nData;
        this.isMobile = com?.isMobile;
    }

    makeMarkup() {
        const platformData = this.data?.platformDownload;
        const platformDataLength = Array.isArray(platformData) && platformData.length > 0 ? platformData.length : 0;
        const downloadTagText = this.l10nData.download || 'Download';
        let innerTmpl = '';

        if(platformDataLength > 0) {
            if(platformDataLength === 1) {
                innerTmpl += `<a href="${platformData[0]?.url || '#'}" 
                class="ncc-gamestart-btn__platform" 
                target="${platformData[0]?.target || '_blank'}" data-contents="홈_다운로드 버튼_선택">
                    <span class="ncc-gamestart-btn__platform-text">${platformData[0]?.name || downloadTagText}</span>
                </a>`;
            } else {
                innerTmpl += `<button type="button" class="ncc-gamestart-btn__platform" data-contents="홈_다운로드 버튼_선택">
                                <span class="ncc-gamestart-btn__platform-text">${downloadTagText}</span>
                            </button>
                            <div class="ncc-gamestart-layer__platform" platform-layer="pc">
                                ${this.makePlatformDownloadListTmpl(platformData)}
                            </div>`;
            }
        }
        
        return `<div class="ncc-gamestart-btn">${innerTmpl}</div>`;
    }

    startSetting() {
        const { useGameStart, platformDownload } = this.data;
        
        if(useGameStart === 'platformDownload' && Array.isArray(platformDownload) && platformDownload?.length > 1) {
            if(this.isMobile) {
                // 모바일일 때 다운로드 플랫폼 레이어 생성
                this.appendMobilePlatformLayer();

                const btnMobileLayerClose = document.querySelector('.mobile-gamestart-layer__platform-close');
                btnMobileLayerClose?.addEventListener('click', e => {
                    this.platformLayerActive(false, 'mobile');
                });
            } else {
                // PC 다운로드 버튼 - 레이어 노출/숨김
                const btnDownloadEle = document.querySelector('button.ncc-gamestart-btn__platform');
                btnDownloadEle?.addEventListener('click', e => {
                    const pcLayerEle = document.querySelector('[platform-layer="pc"]');
                    const isActive = pcLayerEle?.classList?.contains('is-active');
                    this.platformLayerActive(!isActive, 'pc');
                });
            }
        }
    }

    // 플랫폼 다운로드 리스트 템플릿
    makePlatformDownloadListTmpl(data = []) {
        const itemTmpl = data.map(v => `<li class="platform-layer-item">
            <a href="${v.url}" class="platform-layer-item__link ${v.platform} ${!!v.icon ? 'no-icon' : ''}" target="${v.target}">
                ${!!v.icon ? `<span class="platform-layer-item__link-icon" style="background-image: url(${v.icon})"></span>` : ''}
                <span class="platform-layer-item__link-name">${v.name}</span>
            </a>
        </li>`);

        return `<ul class="platform-layer-list">${itemTmpl.join('')}</ul>`;
    }

    // 모바일에서 사용할 플랫폼 리스트 레이어 생성 (body 하위에 심기위해 makeMarkup()에서 생성하지 않음)
    appendMobilePlatformLayer() {
        const tmpl = `<div class="mobile-gamestart-layer__platform" platform-layer="mobile">
            <div class="mobile-gamestart-layer__platform-inner">
                <button type="button" class="mobile-gamestart-layer__platform-close">
                    <span class="hidden">닫기</span>
                </button>
                ${this.makePlatformDownloadListTmpl(this.data?.platformDownload)}
            </div>
            <span class="mobile-gamestart-layer__platform-bg"></span>
        </div>`;

        document.body.insertAdjacentHTML('beforeend', tmpl);
    }

    documentClickCallback = (e) => {
        const { layerEle, wrapEle } = this.getPlatformLayerElement();
        
        if(!wrapEle.contains(e.target) && (!this.isMobile || (this.isMobile && layerEle.contains(e.target)))) {
            this.setPlatformLayerActiveClass(false);
        }
    }

    // 플랫폼 레이어 영역 외 닫기 기능
    documentClickClose(isActive = false) {
        if(isActive) {
            document.addEventListener('click', this.documentClickCallback);
        } else {
            document.removeEventListener('click', this.documentClickCallback);
        }
    }

    // 플랫폼 다운로드 레이어 엘리먼트 반환
    getPlatformLayerElement() {
        const pcLayerEle = document.querySelector('[platform-layer="pc"]');
        const pcLayerWrapEle = document.querySelector('.ncc-header');
        const mobileLayerEle = document.querySelector('[platform-layer="mobile"]');
        const mobileLayerWrapEle = document.querySelector('.mobile-gamestart-layer__platform-inner');
        let layerEle;
        let wrapEle;

        if(this.isMobile) {
            layerEle = mobileLayerEle;
            wrapEle = mobileLayerWrapEle;
        } else {
            layerEle = pcLayerEle;
            wrapEle = pcLayerWrapEle;
        }

        return { layerEle, wrapEle };
    }

    // 플랫폼 다운로드 레이어 노출/숨김 스타일 제어
    setPlatformLayerActiveClass(isActive = false) {
        const { layerEle } = this.getPlatformLayerElement();

        if(this.isMobile) {
            if(isActive) {
                const liItems = layerEle?.querySelectorAll('.platform-layer-item');
                layerEle?.classList?.add('is-active');
                gsap.set(layerEle, {opacity: 0});
                gsap.set(liItems, {opacity: 0, x: 20});
                gsap.to(layerEle, {opacity: 1, duration: 0.4, ease: 'Quad.easeOut'});
                gsap.to(liItems, {opacity: 1, x: 0, duration: 0.4, delay: 0.1, stagger: 0.1, ease: 'Quad.easeOut'});
            } else {
                gsap.to(layerEle, {opacity: 0, duration: 0.3, ease: 'Quad.easeOut', onComplete: () => {
                    layerEle?.classList?.remove('is-active');
                }});
            }
        } else {
            if(isActive) {
                const ulEle = layerEle?.querySelector('.platform-layer-list');
                const ulHeight = ulEle?.clientHeight || 0;
                layerEle?.classList?.add('is-active');
                gsap.to(layerEle, {height: ulHeight, duration: 0.4, ease: 'Quad.easeOut'});
            } else {
                gsap.to(layerEle, {height: 0, duration: 0.33, ease: 'Quad.easeOut', onComplete: () => {
                    layerEle?.classList?.remove('is-active');
                }});
            }
        }
    }

    // 플랫폼 다운로드 레이어 노출/숨김
    platformLayerActive(isActive = false) {
        this.setPlatformLayerActiveClass(isActive);
        this.documentClickClose(isActive);
    }
}

export default PlatformDownload;